<template>
  <div class="app">
    <Header :resData="pagedata.nav"></Header>
    <div class="main">
      <component :resData="pagedata[mainshow]" :is="mainshow"></component>
    </div>
    <Footer :resData="pagedata.footer"></Footer>
  </div>
</template>

<script>
  import Header from '../../components/header.vue';
  import Footer from '../../components/footer.vue';
  import index from '../../components/top.vue';
  import product from '../../components/product.vue';
  import company from '../../components/company.vue';
  export default{
    data(){
      return{
        languages:'Japanese',
        allData:'',
        pagedata:'',
        mainshow:'index'
      }
    },
    components:{
      Header,Footer,index,product,company
    },
    watch:{
      $route(to,from){
        this.mainshow=this.$route.name;
      }
    },
    methods:{
      mainfun(type){
        this.mainshow=type
      },
      languagefun(val){
        this.$cookieStore.addCookie( 'languages',val,1);
        this.pagedata=this.allData[val];
      },
      getlan(){
        // console.log(this.languages);
        if(this.$cookieStore.getCookie( 'languages') && this.$cookieStore.getCookie( 'languages')!=undefined){
          this.languages=this.$cookieStore.getCookie( 'languages');
          console.log(this.languages);
          // Japanese
        }
        this.axios.get('./static/language.json').then(res => {
            this.allData=res.data.data;
            this.pagedata=res.data.data[this.languages];
        })
      }
    },
    mounted(){
      this.mainshow=this.$route.name;
    }
  }
</script>

<style scoped>
  .main{
    background-color: #F7F7F7;
    min-height: calc(100vh - 295px);
    box-sizing: border-box;
    padding-bottom: 3%;
  }
  @media screen and (max-width: 1000px){
    .app{
        max-width: 750px;
        margin: auto;
    }
    .main{
      min-height: calc(100vh - 280px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue